
import { BY_MONTH, BY_PAYEE } from 'components/SpendingWithRegister/config';
import { isAcme } from 'isAcme';

const acmeBasic = {
  xs: 12,
  md: 12,
  lg: 6,
  xl: 4,
};
const acmeStretch = {
  xs: 12,
  md: 12,
  lg: 12,
  xl: 8,
};

export const overviewLayoutVersion = isAcme ? '1.2' : '1.0';

export const overviewCards = !isAcme ? {
  // QUICKEN CARDS
  transactions: {
    label: 'Recent Transactions',
    name: 'transactions',
    xs: 12,
    lg: 6,
    titleNav: '/transactions?displayNode=all',
    defaultOrder: 1,
  },
  upcoming: {
    label: 'Upcoming',
    name: 'upcoming',
    xs: 12,
    lg: 6,
    titleNav: '/bills-and-income',
    defaultOrder: 2,
  },
  spendingCats: {
    label: 'Spending by Category',
    name: 'spendingCats',
    xs: 12,
    lg: 6,
    titleNav: isAcme ? '/reports/spending/by-category' : '/spending',
    defaultOrder: 3,
  },
  budgets: {
    label: 'Budgets',
    name: 'budgets',
    xs: 12,
    lg: 3,
    titleNav: '/budgets',
    defaultOrder: 4,
  },
  spendingTime: {
    label: 'Spending Over Time',
    name: 'spendingTime',
    xs: 12,
    lg: 6,
    titleNav: isAcme ? '/reports/spending/by-month' : `/spending?selectTab=${BY_MONTH}`,
    defaultOrder: 6,
  },
  investments: {
    label: 'Investment Summary',
    name: 'investments',
    xs: 12,
    lg: 3,
    titleNav: '/investments?displayNode=INVESTMENT',
    defaultOrder: 7,
  },
  netIncome: {
    label: 'Net Income Over Time',
    name: 'netIncome',
    xs: 12,
    lg: 6,
    titleNav: isAcme ? '/reports/net-income/net-income' : '/net-income',
    defaultOrder: 8,
  },
  investmentsMovers: {
    label: 'Investment Top Movers',
    name: 'investmentsMovers',
    xs: 12,
    lg: 6,
    titleNav: '/investments?displayNode=INVESTMENT',
    defaultOrder: 9,
  },
  topPayees: {
    label: 'Top Payees this Month',
    name: 'topPayees',
    xs: 12,
    lg: 3,
    titleNav: isAcme ? '/reports/spending/by-payee' : `/spending?selectTab=${BY_PAYEE}`,
    defaultOrder: 10,
  },
  watchList: {
    label: 'Watchlist',
    name: 'watchList',
    xs: 12,
    lg: 8,
    titleNav: '/watchlist',
    defaultOrder: 11,
  },
  incomeTime: {
    label: 'Income By Month',
    name: 'incomeTime',
    xs: 12,
    lg: 6,
    titleNav: '/reports/income/by-month',
    defaultOrder: 12,
  },
} : {

  // ACME CARDS

  netWorth: {
    label: 'Net Worth',
    name: 'netWorth',
    titleNav: '/transactions?displayNode=all',
    defaultOrder: 1,
    ...acmeBasic,
  },
  spendingPlan: {
    label: 'Spending Plan',
    name: 'spendingPlan',
    ...acmeBasic,
    titleNav: '/spending-plan',
    defaultOrder: 2,
  },
  upcomingAcme: {
    label: 'Upcoming',
    name: 'upcomingAcme',
    ...acmeBasic,
    titleNav: '/transactions?displayNode=all',
    defaultOrder: 3,
  },
  transactions: {
    label: 'Recent Transactions',
    name: 'transactions',
    ...acmeBasic,
    titleNav: '/transactions?displayNode=all',
    defaultOrder: 4,
  },
  spendingCats: {
    label: 'Spending by Category',
    name: 'spendingCats',
    ...acmeBasic,
    titleNav: isAcme ? '/reports/spending/by-category' : '/spending',
    defaultOrder: 5,
  },
  spendingTime: {
    label: 'Spending Over Time',
    name: 'spendingTime',
    ...acmeBasic,
    titleNav: isAcme ? '/reports/spending/by-month' : `/spending?selectTab=${BY_MONTH}`,
    defaultOrder: 6,
  },
  watchList: {
    label: 'Watchlist',
    name: 'watchList',
    ...acmeStretch,
    titleNav: '/watchlist',
    defaultOrder: 7,
  },
  incomeTime: {
    label: 'Income By Month',
    name: 'incomeTime',
    ...acmeBasic,
    titleNav: '/reports/income/by-month',
    defaultOrder: 8,
  },
};

const overviewLayoutQuicken = [
  {
    key: 'transactions',
    value: true,
  },
  {
    key:'spendingCats',
    value:true,
  },
  {
    key: 'budgets',
    value:true,
  },
  {
    key:'spendingTime',
    value:true,
  },
  {
    key:'investments',
    value:true,
  },
  {
    key:'netIncome',
    value:true,
  },
  {
    key: 'investmentsMovers',
    value:true,
  },
  {
    key:'topPayees',
    value:true,
  },
];
const overviewLayoutAcme = [
  {
    key:'spendingPlan',
    value:true,
  },
  {
    key:'transactions',
    value:true,
  },
  {
    key: 'upcomingAcme',
    value:true,
  },
  {
    key:'spendingCats',
    value:true,
  },
  {
    key:'watchList',
    value:true,
  },
  {
    key:'spendingTime',
    value:true,
  },
  {
    key:'incomeTime',
    value:true,
  },
];

export const overviewLayout = isAcme ? overviewLayoutAcme : overviewLayoutQuicken;
